import * as React from 'react';
import '@patternfly/react-core/dist/styles/base.css';
import '@patternfly/react-topology/dist/esm/css/topology-components.css';
import '@patternfly/react-topology/dist/esm/css/topology-controlbar.css';
import '@patternfly/react-topology/dist/esm/css/topology-pipelines.css';
import '@patternfly/react-topology/dist/esm/css/topology-side-bar.css';
import '@patternfly/react-topology/dist/esm/css/topology-view.css';

import { Route, Routes } from 'react-router-dom';
import { AppLayout } from '@app/AppLayout/AppLayout';
import { AppRoutes } from '@app/routes';
import '@app/app.css';
import { LoggerProvider } from 'src/providers/LoggerProvider';
import WebSocketProvider from 'src/providers/WebSocketProvider';
import AdminGate from '@app/Auth/AdminGate';
import SignInPage from '@app/Auth/SignInPage';

function App() {
  return (
    <Routes>
      <Route path="/sign-in/*" element={<SignInPage />} />
      <Route
        path="/*"
        element={
          <AdminGate>
            <AppLayout>
              <LoggerProvider>
                <WebSocketProvider>
                  <AppRoutes />
                </WebSocketProvider>
              </LoggerProvider>
            </AppLayout>
          </AdminGate>
        }
      />
    </Routes>
  );
}

export default App;
